import { render, staticRenderFns } from "./DlgAnimalsNew.vue?vue&type=template&id=7d33f21e&scoped=true&"
import script from "./DlgAnimalsNew.vue?vue&type=script&lang=ts&"
export * from "./DlgAnimalsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d33f21e",
  null
  
)

export default component.exports